// Constants for dropdown specific components.
// @flow

import { urlFormatter } from '../../../api/request';

export type Suggestion = {
    id?: number,
    text: text,
    image: text,
    allOption?: boolean
};

export const ORG_LOGO_BASE_URL = urlFormatter('/avatars/org');
